<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Lista de Requests</h4>

          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <!-- <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div> -->
        <div class="table-responsive table-full-width">
          <el-table
              :data="tableData()"
              style="width: 100%">
              <el-table-column type="expand">
              <template slot-scope="props">
                <p>
                  <span class="expandrow">Criado em : </span>{{ props.row.created }}
                  <p></p>
                  <span class="expandrow">Atualizado: </span>{{ props.row.updated }}
                  <p></p>
                  <span class="expandrow">URL: </span>{{ props.row.url }}
                  <p></p>
                  <span class="expandrow" v-if="props.row.error">Erros: </span>{{ props.row.error }}
                </p>
                <template>
                  <json-view v-if="props.row.response" :data="props.row.response" :maxDepth="0" rootKey="Resposta"/>
                </template>
                <template>
                  <json-view v-if="props.row.payload" :data="props.row.payload" :maxDepth="0" rootKey="Payload" />
                </template>
              </template>
              </el-table-column>
              <el-table-column
              label="VM"
              prop="vm.location">
              </el-table-column>
              <el-table-column
              label="Metodo"
              prop="method">
              </el-table-column>
              <el-table-column
              label="Status"
              prop="response_status">
              </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Tooltip } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      companyList: [],
      requests: [],
      search: '' ,
      machines: []
    };
  },
  computed: {
  },
  created() {
    var ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) { 
      ciaID = ciaID
    } else {
      ciaID = ''
    }
    this.$store.dispatch("machines/listSort", {sort: '?page_size=300'  + '&company=' + ciaID}).then(resp => {
      this.machines = resp
    }).then(() =>{
      this.$store.dispatch("lockers/listSort", {sort: '?page_size=300'  + '&company=' + ciaID}).then(resp => {
        for (let index = 0; index < resp.length; index++) {
          this.machines.push(resp[index])
        }
        console.log('machines', this.machines)
      }).then (()=>{this.$store.dispatch("requests/listSort", {sort: '?company=' + ciaID}).then(()=>{
        this.tableData()
      }).catch(err => console.log(err));
      })
    })
    // this.getListCompany()
    console.log('store', this.$store.state)
  },
  mounted () {
    this.getListCompany()
  },
  methods: {
    // getListCompany () {
    //   this.$store.dispatch('general/listUser').then(()=> {
    //     var x = this.$store.state.general.listUser.user_list_info
    //     this.companyList = x.filter((thing, index, self) =>
    //       index === self.findIndex((t) => (
    //         t.profile__company__id === thing.profile__company__id && t.profile__company__name === thing.profile__company__name
    //       ))
    //     )
    //   })
    // },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    tableData() {
      this.requests = this.$store.state.requests.requests
      const machines =  this.machines
      const populated = this.requests.map(v =>{
        let vm, updated, created
        if (v.vm) {
          vm = machines.find(e => e.id == v.vm);
        }
        if (v.updated) {
          const d = new Date(v.updated);
          updated = d.toLocaleString("pt-BR");
        }
        if (v.created) {
          const h = new Date(v.created);
          created = h.toLocaleString("pt-BR");
        }
        return { ...v, vm, updated, created };
      })
      return populated
    },
    permission (permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
        if (el == permissao) {
          return true
        } 
      })
      if (x.length > 0) {
        return true
      }
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
span.expandrow {
  font-weight: bold;
}
</style>
